import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { TableBaseStyle } from './StudySettingStyle';
import { STUDY_SET_1 } from './StudySetting';
import NumericEntry_inputEx from './../../../atoms/Input/NumericEntry_inputEx';

type StudySettingGridRowProps = {
  studySet1: STUDY_SET_1;
  rowIndexNo: number;
  onChangeData: (targetRow: STUDY_SET_1) => void;
};

const StudySettingGridRow: React.FC<StudySettingGridRowProps> = (props) => {
  const tableStyle = TableBaseStyle();
  const [studySetting1, setStudySetting1] = useState<STUDY_SET_1>(props.studySet1); //データ初期値
  const [isEdit, setIsEdit] = useState<boolean>(false); //変更フラグ データを編集したらtrue

  /**
   * データ変更通知
   */
  useEffect(() => {
    //データ初期値にセットされている内容を再描画時に変えたい場合、useEffectが必要
    //console.debug(['StudySettingGridRow - useEffect props.studySet1', props.studySet1]);
    setStudySetting1({ ...props.studySet1 });
    setIsEdit(false);
  }, [props.studySet1]);

  /**
   * 値を変更した内容を管理
   * @param key
   * @returns
   */
  const onChangeCell = (key: string, value: any) => {
    console.debug(['onChangeCell - key isEdit', key, isEdit]);
    setIsEdit(true);
    setStudySetting1({ ...studySetting1, [key]: value });
  };

  /**
   * 上位にデータ変更通知
   * @param editRow　編集対象データ
   * @param isEdit 編集フラグ
   * @returns
   */
  const onChangeData = (editRow: STUDY_SET_1, editFlg: boolean) => {
    if (editFlg) {
      //console.debug(['onChangeData - editRow,baseData', editRow, props.studySet1]);
      props.onChangeData(editRow);
    }
  };

  return (
    <TableRow key={props.rowIndexNo}>
      {/* No */}
      <TableCell className={tableStyle.bodyCell} width={40}>
        <div>{props.rowIndexNo}</div>
      </TableCell>
      {/* 名称 */}
      <TableCell className={tableStyle.bodyCell} width={200}>
        <div>{studySetting1.CLC_TYPE_NAME}</div>
      </TableCell>
      {/* 演算種別 */}
      <TableCell className={tableStyle.bodyCell} width={200}>
        <div>{studySetting1.TYP_NAME}</div>
      </TableCell>
      {/* 軽故障 */}
      <TableCell className={tableStyle.bodyCell} width={100}>
        <NumericEntry_inputEx
          className={tableStyle.textField}
          value={studySetting1.WRN_NUM ?? 0}
          minValueLimit={0}
          maxValueLimit={9.99}
          fixed={2}
          onChange={(val) => {
            if (props.studySet1.WRN_NUM !== val) {
              //コンポーネント側で値を更新しているの、描画しなおさなくてもいい為直接セット
              studySetting1.WRN_NUM = val;
              //上位に変更通知
              onChangeData(studySetting1, true);
              console.debug(['NumericEntry_inputEx - onChange - WRN_NUM', val, studySetting1]);
            }
          }}
        />
      </TableCell>
      {/* 重故障 */}
      <TableCell className={tableStyle.bodyCell} width={100}>
        <NumericEntry_inputEx
          className={tableStyle.textField}
          value={studySetting1.ALM_NUM ?? 0}
          minValueLimit={0}
          maxValueLimit={9.99}
          fixed={2}
          onChange={(val) => {
            if (props.studySet1.ALM_NUM !== val) {
              //コンポーネント側で値を更新しているの、描画しなおさなくてもいい為直接セット
              studySetting1.ALM_NUM = val;
              //上位に変更通知
              onChangeData(studySetting1, true);
              console.debug(['NumericEntry_inputEx - onChange - ALM_NUM', val, studySetting1]);
            }
          }}
        />
      </TableCell>
    </TableRow>
  );
};

export default StudySettingGridRow;
